/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import { Component } from 'preact';
import Switch from 'react-toggle-switch';
import { Link } from 'preact-router';
import style from './style.scss';

import { langPack } from '../../utils/langPack';

class RadioButtons extends Component {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    valueField: 'value',
    value: {
      radio: '',
    },
  };

  generateId = (el) => {
    const { valueField, name } = this.props;
    return `${el[valueField]}_${name}`;
  }

  // eslint-disable-next-line consistent-return
  getItem = (el, parent = '') => {
    const { valueField } = this.props;
    if (el.type === 'radio' || !el.type) {
      if (el[valueField] !== 'pro') {
        const value = parent ? `${parent}.${el[valueField]}` : el[valueField];
        const checked = value === this.props.value.radio;

        // Show submenu
        const showChildren = el.childs && el.childs.length && !parent && (checked || this.props.value.radio.indexOf(value) === 0);

        return (
          el[valueField] !== 'payment'
            ? (
              <div>
                <input
                  type="radio"
                  id={this.generateId(el)}
                  disabled={el.disabled}
                  name={el.name}
                  value={value}
                  checked={checked}
                />
                <label
                  htmlFor={this.generateId(el)}
                >
                  {el.name}
                </label>
                <div
                  className={style.children}
                  style={{
                    height: showChildren ? `${28 * el.childs.length}px` : 0,
                    width: !showChildren ? 0 : 'auto',
                  }}
                >
                  {el.childs ? el.childs.map((item) => this.getItem(item, value)) : null}
                </div>
              </div>
            )
            : (
              <div>
                <input
                  type="radio"
                  id={this.generateId(el)}
                  disabled={el.disabled}
                  name={el.name}
                  value={value}
                  checked={checked}
                />
                <label
                  htmlFor={this.generateId(el)}
                  onClick={() => firebase.analytics().logEvent('Tap_Payment_settings')}
                >
                  {el.name}
                </label>
              </div>
            )
        );
      }
      return ([
        <input
          type="radio"
          id={this.generateId(el)}
          disabled={el.disabled}
          name={el.name}
          value={el[valueField]}
          checked={el[valueField] === this.props.value.radio}
        />,
        <div className={style.wrapProDeatils}>
          <label htmlFor={this.generateId(el)} onClick={() => firebase.analytics().logEvent('Pro_details')}>{el.name}</label>
          {/* <span className={style.proDetailsApproved}>&#10004;&nbsp;{langPack[this.props.locale].RADIO_BUTTONS.APPROVED}</span> */}
          <span className={style.proDetailsApproved}>&#10004;&nbsp;Approved</span>
        </div>,
      ]);
    }
    if (el.type === 'link') {
      return ([
        <input
          type="radio"
          id={this.generateId(el)}
          disabled={el.disabled}
          name={el.name}
          value={el[valueField]}
          checked={el[valueField] === this.props.value.radio}
        />,
        <div className={style.wrapProDeatils}>
          <Link href={el.href}>
            <label htmlFor={this.generateId(el)}>{el.name}</label>
          </Link>
        </div>,
      ]);
    }
    if (el.type === 'switch') {
      if (el[valueField] === 'proWork') {
        return (
          <div className={`${style.switch} ${this.props.isPro && el[valueField] === 'proWork' && !this.props.value.switch[el[valueField]] ? style.redSwitch : ''}`}>
            <div>{el.name}</div>
            <Switch
              onClick={() => {
                this.props.onSwitch(el[valueField]);
                firebase.analytics().logEvent('Work_as_Pro');
              }}
              on={this.props.value.switch[el[valueField]]}
              className={style.switchcell}
            />
          </div>
        );
      } if (el[valueField] === 'emailNotification') {
        return (
          <div className={`${style.switch}`}>
            <div>{el.name}</div>
            <Switch
              onClick={() => {
                this.props.onSwitch(el[valueField]);
                firebase.analytics().logEvent('Switch_Important_via_Email');
              }}
              on={this.props.value.switch[el[valueField]]}
              className={style.switchcell}
            />
          </div>
        );
      }
      return (
        <div className={`${style.switch}`}>
          <div>{el.name}</div>
          <Switch onClick={() => this.props.onSwitch(el[valueField])} on={this.props.value.switch[el[valueField]]} className={style.switchcell} />
        </div>
      );
    }

    if (el.type === 'text') {
      return (
        <div className={style.text}>
          {el.name}
        </div>
      );
    }
  }

  render() {
    const { data, onChange, footer, className } = this.props;

    return (
      <div className={style.leftSideBar}>
        <div>
          <form
            className={className}
            onChange={(e) => onChange(e.target.value, e.target.name)}
          >
            <div className={style.options}>
              {data.name === 'SECTORS' ? (
                <div className={style.sideBarInWrapper}>
                  <span className={style.sideBarTitle}>{langPack[this.props.locale].RADIO_BUTTONS.SECTORS}</span>
                  <div className={style.sideBarInWrapper}>
                    {data.map((el) => el !== 'name' && this.getItem(el))}
                  </div>
                </div>
              ) : (
                data.map((el) => ([
                  <span className={style.sideBarTitle}>
                    {el.name}
                  </span>,
                  el.links.map((item) => this.getItem(item)),
                ]))
              )}
            </div>
          </form>
        </div>
        {
          footer ? (
            <div className={style.footer}>
              <span onClick={() => {
                footer.onClick();
                firebase.analytics().logEvent('Sign_out');
              }}
              >
                {footer.text}
              </span>
            </div>
          ) : null
        }
      </div>
    );
  }
}

export default RadioButtons;



// WEBPACK FOOTER //
// ./components/radio-buttons/leftSideBar.js